const themesVariables = {
  lightPrimaryMainColor: "rgb(63, 63, 63)",
  lightPrimaryLightColor: "#cccccc",
  lightPrimarydarkColor: "#000000",
  lightPrimaryContrastTextColor: "#ffffff",
  lightSecondaryMainColor: "rgb(68 101 179)",
  lightSecondaryLightColor: "rgb(68 101 179)",
  lightSecondaryDarkColor: "rgb(68 101 179)",
  lightSecondaryContrastTextColor: "#ffffff",
  fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif",
  fontSize: 14,
};

export default themesVariables;
